export default "__VITE_ASSET__f95211a7__"